<script>
  import SectionRenderer from '../components/SectionRenderer.vue';
  import sections from './sections.json';
  import HashChangeListenerMixin from '@/views/app/dashboard/footer-pages/components/HashChangeListenerMixin';

  export default {
    name: 'ResponsibleGaming',
    components: { SectionRenderer },
    mixins: [HashChangeListenerMixin(sections, [...sections.info[0].children, ...sections.faq[0].children])],
    data: () => ({
      isScrolling: false,
    }),
    metaInfo() {
      return {
        title: 'Responsible Gaming',
        meta: [
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ],
      };
    },
    computed: {
      infoIndex() {
        if (this.activeSectionIndex > this.sections.info[0].children.length - 1) return null;
        return this.activeSectionIndex;
      },
      faqIndex() {
        const infoLength = this.sections.info[0].children.length;
        if (this.activeSectionIndex > infoLength - 1) return this.activeSectionIndex - infoLength;
        return null;
      },
    },
  };
</script>
<template>
  <div class="page-container">
    <div class="page">
      <div class="content">
        <h1 class="mb-3">RESPONSIBLE GAMING</h1>
        <span class="white--text mb-4 d-block">Version: 1.0 | Last updated: May 2, 2024.</span>
        <p class="mt-4">
          Welcome to MaxQuest, where dedication to fostering a positive online social gaming environment is a top
          priority. Responsible gaming practices are in place to ensure the well-being of MaxQuest’s valued community.
          By adhering to industry standards and implementing effective measures, MaxQuest aims to promote enjoyable and
          responsible gameplay experiences for all.
        </p>
        <p>
          It's important to note that MaxQuest reserves the right to decline the reopening of any closed account, even
          after the review process. This decision will be made based on various contributing factors, including but not
          limited to compliance history, responsible gaming considerations, and any evidence supporting the decision
          made by MaxQuest.
        </p>
        <section-renderer
          class="mt-6"
          :sections="sections.info"
          @click="handleSectionClick"
          :active-section-index="infoIndex"
        />
        <h2>Frequently Asked Questions</h2>
        <section-renderer
          class="mt-6"
          :sections="sections.faq"
          @click="handleSectionClick"
          :active-section-index="faqIndex"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import '../components/style.scss';

  ::v-deep .content {
    & > span {
      font-size: 14px !important;
      font-weight: 400;
    }
    ol > li::before {
      content: '';
    }
  }
</style>
